import script from "./VMenuButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./VMenuButton.vue?vue&type=script&lang=ts&setup=true"

import "./VMenuButton.vue?vue&type=style&index=0&id=6d4a4d79&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4a4d79"]])

export default __exports__